import * as styles from 'styles/pages/Styleguide.css'
import themes from 'styles/base/themes.styl'
import cn from 'classnames'
import Button from 'components/features/pfm/Button/Button'
import Flex, { FlexProps } from 'components/atoms/Flex/Flex'
import Separator from 'components/atoms/Separator/Separator'
import { Theme } from 'interfaces/component'
import { PageAnchorHandler } from 'handlers/PageAnchorHandler/PageAnchorHandler'
import { Anchor } from 'interfaces/navigation'
import FloatingPaneNotification from 'components/features/pfm/FloatingPaneNotification/FloatingPaneNotification'
import { TooltipIcon } from 'components/atoms/TooltipIcon/TooltipIcon'

type ContentTemplateProps =
& FlexProps
&{

  title: string
  classNames?: string
}

type ButtonRowProps = {
  title: string
  placement: Anchor
  themeArray: Theme[]
}

const ContentTemplate = ({ title, classNames = themes.info, ...flexProps }: ContentTemplateProps) => (
  <Flex className={ cn(styles.contentTemplate, classNames) } gap='none' { ...flexProps }>
    {/* <h3>{ title }</h3> */}
    <h4>{ title }</h4>
    <p>Eu laborum Lorem et ut aute voluptate ut mollit dolor exercitation consectetur ea.</p>
    <br />
    <a>A Link Somewhere</a>
  </Flex>
)
const ButtonRow = ({ title, placement, themeArray }: ButtonRowProps) => (
  <PageAnchorHandler placement={ placement }>
    <h2 className={ styles.sgHeading }>{ title }</h2>
    <Flex horizontal className={ styles.sgSection }>
      { themeArray.map((theme, idx) => (
        <Flex key={ idx } horizontallyCenter>
          <TooltipIcon content='My tooltip icon hint ' theme={ theme } />
          <strong style={{ textAlign: 'center' }}>{ theme }</strong>
          <Button iconSlug='star' text='Default' size='tiny' theme={ theme } />
          <Button iconSlug='star' text='Outlined' size='tiny' theme={ theme } style='outlined' />
          <Button iconSlug='star' text='Hollow' size='tiny' theme={ theme } style='hollow' />
          <Button iconSlug='star' text='Text Only' size='tiny' theme={ theme } style='textOnly' />
          <Button iconSlug='star' text='Text Only Big' size='tiny' theme={ theme } style='textOnlyBig' />
          <ContentTemplate title='Default' classNames={ cn(themes[theme]) } />
          <ContentTemplate title='Outlined' classNames={ cn(themes[theme], themes.outlined) } />
          <ContentTemplate title='Hollow' classNames={ cn(themes[theme], themes.hollow) } />
          <ContentTemplate title='Notification' classNames={ cn(themes[theme], themes.notification) } />
          <FloatingPaneNotification text='Notification' theme={ theme } onDismiss={ console.log } />
          <ContentTemplate title='Insight' classNames={ cn(themes[theme], themes.insight) } />
          <ContentTemplate title='Text Only' classNames={ cn(themes[theme], themes.textOnly) } />
        </Flex>
      ))}
    </Flex>
    <Separator />
  </PageAnchorHandler>
)


const SGThemes = () => (
  <PageAnchorHandler placement='themes'>
    <h2 className={ styles.sgHeading }>Paddings / Border Radius</h2>
    <Flex horizontal className={ styles.sgSection }>
      <ContentTemplate title='None' padding='none' />
      <ContentTemplate title='Micro' padding='micro' rounded />
      <ContentTemplate title='Tiny' padding='tiny' rounded />
      <ContentTemplate title='Small' padding='small' rounded />
      <ContentTemplate title='Default' padding='defaultSize' rounded />
      <ContentTemplate title='Medium' padding='medium' rounded />
      <ContentTemplate title='Large' padding='large' rounded />
      <ContentTemplate title='X-Large' padding='xlarge' rounded />
    </Flex>
    <Flex>
      <ButtonRow
        title='Primary'
        placement='themes_primary'
        themeArray={ ['cyan', 'green', 'yellow', 'orange', 'danger'] }
      />
      <ButtonRow
        title='Light Primary'
        placement='themes_light_primary'
        themeArray={ ['lightBlue', 'lightCyan', 'lightGreen', 'lightOrange', 'lightRed'] }
      />
      <ButtonRow
        title='Dark Primary'
        placement='themes_dark_primary'
        themeArray={ ['darkBlue', 'darkCyan', 'darkGreen', 'darkOrange', 'darkRed'] }
      />
      <ButtonRow
        title='Feature'
        placement='themes_feature'
        themeArray={ ['blue', 'premium', 'creditCard', 'event', 'goal', 'golden'] }
      />
      <ButtonRow
        title='Brand'
        placement='themes_brand'
        themeArray={ ['advisorTopicSelected', 'card', 'advisorTopic', 'oxford', 'coral', 'merlot'] }
      />
      <ButtonRow
        title='Neutral'
        placement='themes_neutral'
        themeArray={ ['snow', 'satin', 'stone', 'darkGray', 'midnight'] }
      />
    </Flex>
  </PageAnchorHandler>
)

export default SGThemes
